import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen pt-20 flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <div className="w-24 h-24 mx-auto mb-8 bg-soft-gray rounded-full flex items-center justify-center">
          <span className="font-heading text-4xl text-copper">404</span>
        </div>
        
        <h1 className="font-heading text-3xl md:text-4xl text-graphite mb-4">
          Página no encontrada
        </h1>
        <p className="text-muted-foreground mb-8">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            asChild
            variant="outline"
            className="rounded-full"
          >
            <Link to="/">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Volver atrás
            </Link>
          </Button>
          <Button
            asChild
            className="bg-copper hover:bg-copper-dark text-cream rounded-full"
          >
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Ir al inicio
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
